import { FC, PropsWithChildren } from 'react'
import { useSPRemixTable } from '../hooks'
import { ArpTableContext } from './ArpTableContext'

interface SPRemixRootProps extends PropsWithChildren {
  id: number
}
export const SPRemixRoot: FC<SPRemixRootProps> = ({ id, children }) => {
  const contextData = useSPRemixTable(id)
  return <ArpTableContext.Provider value={contextData}>{children}</ArpTableContext.Provider>
}
